module.exports = __webpack_public_path__ + "img/quotes-lukas-meisner.91f3cebb.png";